module.exports = __webpack_public_path__ + "768e136e4b8e5cd7ab7c2a67ffe5e52e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Splash/images/thumbs/thumb1.jpg
// module id = ./src/views/Splash/images/thumbs/thumb1.jpg
// module chunks = 0